import posthog from 'posthog-js';
import { getPostHogBrowserOptions } from '@/lib/posthog';

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;

function hasStoredMeasurementConsent(): boolean {
  try {
    const cookie = document.cookie.match(/(?:^|;\s*)c15t=([^;]*)/);
    if (cookie?.[1]?.includes('c.measurement:1')) return true;
  } catch {}

  try {
    const stored = window.localStorage.getItem('c15t');
    if (stored) return Boolean(JSON.parse(stored)?.consents?.measurement);
  } catch {}

  return false;
}

if (posthogKey && !posthog.__loaded) {
  posthog.init(posthogKey, getPostHogBrowserOptions());

  if (hasStoredMeasurementConsent()) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}
